import type { AppUserRole } from "shared/auth/constants/roles";

/**
 * Sidebar menu entry shape. Icons are described as data so this file can
 * remain a plain `.ts` module; `Sidebar.tsx` renders them into JSX.
 */
export type SidebarMenuItem = {
  key: string;
  label: string;
  path?: string;
  iconSrc?: string;
  iconAlt?: string;
  iconClass?: string;
  soon?: boolean;
};

export const creatorMenuItems: SidebarMenuItem[] = [
  {
    key: "library",
    label: "Library",
    path: "/home/library",
    iconSrc: "/images/sidebar/Library.svg",
    iconAlt: "Library",
    iconClass: "menu-icon2",
  },
  {
    key: "pair_headset",
    label: "Venue screenings",
    path: "/home/pair_headset",
    iconSrc: "/images/sidebar/Pair headset.svg",
    iconAlt: "Venue screenings",
    iconClass: "menu-icon2",
  },
  {
    key: "profile",
    label: "Profile",
    path: "/home/profile",
    iconSrc: "/images/sidebar/Profile.svg",
    iconAlt: "Profile",
    iconClass: "menu-icon2",
  },
  {
    key: "analytics",
    label: "Analytics",
    path: "/home/analytics",
    iconSrc: "/images/sidebar/Analytics.svg",
    iconAlt: "Analytics",
    iconClass: "menu-icon2",
  },
];

export const userMenuItems: SidebarMenuItem[] = [
  {
    key: "home",
    label: "Home",
    path: "/home",
    iconSrc: "/images/sidebar/Home.svg",
    iconAlt: "Home",
    iconClass: "menu-icon",
  },
  {
    key: "browse",
    label: "Browse all",
    path: "/browse",
    iconSrc: "/images/sidebar/Browse all.svg",
    iconAlt: "Browse all",
    iconClass: "menu-icon2",
  },
  {
    key: "watchlist",
    label: "Watchlist",
    path: "/watchlist",
    iconSrc: "/images/sidebar/Watchlist.svg",
    iconAlt: "Watchlist",
    iconClass: "menu-icon2",
  },
  {
    key: "pair_headset",
    label: "Pair headset",
    path: "/home/pair_headset",
    iconSrc: "/images/sidebar/Pair headset.svg",
    iconAlt: "Pair headset",
    iconClass: "menu-icon2",
  },
  {
    key: "profile",
    label: "Account",
    path: "/home/profile",
    iconSrc: "/images/sidebar/Profile.svg",
    iconAlt: "Account",
    iconClass: "menu-icon2",
  },
];

export const curatorMenuItems: SidebarMenuItem[] = [
  {
    key: "movie_review",
    label: "Movie review",
    path: "/home/movie-review",
    iconSrc: "/images/sidebar/Library.svg",
    iconAlt: "Library",
    iconClass: "menu-icon2",
  },
  {
    key: "profile",
    label: "Account",
    path: "/home/profile",
    iconSrc: "/images/sidebar/Profile.svg",
    iconAlt: "Profile",
    iconClass: "menu-icon2",
  },
];

/**
 * Pick the sidebar menu for a given role. Matches the previous behavior in
 * `features/shell/components/Sidebar.tsx`:
 *  - CREATOR              → creator menu
 *  - CURATOR (creator-layout role, not CREATOR) → curator menu
 *  - Everything else      → user menu
 */
export function getSidebarMenuForRole(
  role: AppUserRole | null
): SidebarMenuItem[] {
  if (role === "ADMIN") return [curatorMenuItems[0], ...creatorMenuItems];
  if (role === "CREATOR") return creatorMenuItems;
  if (role === "CURATOR") return curatorMenuItems;
  return userMenuItems;
}
